var _path, _path2, _rect;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBattery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 14,
    viewBox: "0 0 26 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4821 5C25.0343 5 25.4821 5.44772 25.4821 6V8C25.4821 8.55228 25.0343 9 24.4821 9V5Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.48206 1H20.4821C22.1389 1 23.4821 2.34315 23.4821 4V10C23.4821 11.6569 22.1389 13 20.4821 13H3.48206C1.8252 13 0.482056 11.6569 0.482056 10V4C0.482056 2.34315 1.8252 1 3.48206 1ZM3.48206 2C2.37749 2 1.48206 2.89543 1.48206 4V10C1.48206 11.1046 2.37749 12 3.48206 12H20.4821C21.5866 12 22.4821 11.1046 22.4821 10V4C22.4821 2.89543 21.5866 2 20.4821 2H3.48206Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.48206,
    y: 3,
    width: 19,
    height: 8,
    rx: 1,
    fill: "black"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBattery);
export default __webpack_public_path__ + "static/media/Battery.efc69cdb8ddc5aa6c969e2466ccfa794.svg";
export { ForwardRef as ReactComponent };